import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faXmark, faRightToBracket, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import './AuthPromptModal.css';

// Giriş yapılmadan korumalı bir aksiyon (ör. "Satın al") denendiğinde açılan
// davet modalı. Giriş/Kayıt'a gidince kullanıcı bu sayfaya geri dönebilsin diye
// mevcut konumu state.from olarak taşır.
const AuthPromptModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Açıkken Esc ile kapat + arka plan kaydırmasını kilitle.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  const go = (path) => {
    onClose();
    navigate(path, { state: { from: location } });
  };

  return (
    <div className="auth-modal-backdrop" onClick={onClose}>
      <div
        className="auth-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="auth-modal-close"
          onClick={onClose}
          aria-label={t('authprompt.close')}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <span className="auth-modal-icon">
          <FontAwesomeIcon icon={faLock} />
        </span>

        <h2 id="auth-modal-title" className="auth-modal-title">
          {t('authprompt.title')}
        </h2>
        <p className="auth-modal-message">{t('authprompt.message')}</p>

        <div className="auth-modal-actions">
          <button
            type="button"
            className="auth-modal-primary"
            onClick={() => go('/login')}
          >
            <FontAwesomeIcon icon={faRightToBracket} />
            {t('auth.action.login')}
          </button>
          <button
            type="button"
            className="auth-modal-secondary"
            onClick={() => go('/signup')}
          >
            <FontAwesomeIcon icon={faUserPlus} />
            {t('auth.action.signup')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthPromptModal;
